import React from 'react'



const Navbar = () => {

  return (
    <div className='w-full py-3 px-8 flex items-center gap-4 border-b-[#D9D9D9] border-b-[1px] h-16   '>
      <div className='flex gap-4 items-center w-1/3'>
        <p className='text-[#1A181E] text-[0.9375rem]  font-normal leading-[1.375rem] '>Payments</p>

        <span className='flex gap-2 text-[#4D4D4D] items-center justify-center'>
          {/* <span className='w-3 h-3 '> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g clip-path="url(#clip0_51935_2522)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77783 10.1808C7.77783 10.6103 7.42968 10.9584 7.00022 10.9584C6.57076 10.9584 6.22261 10.6103 6.22261 10.1808C6.22261 9.75137 6.57076 9.40322 7.00022 9.40322C7.42968 9.40322 7.77783 9.75137 7.77783 10.1808Z" fill="#4D4D4D" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.12724 3.40771C6.54406 3.23506 7.00271 3.18988 7.4452 3.2779C7.88769 3.36592 8.29414 3.58317 8.61315 3.90219C8.93217 4.2212 9.14942 4.62765 9.23744 5.07014C9.32546 5.51263 9.28028 5.97128 9.10763 6.3881C8.93498 6.80491 8.64261 7.16117 8.26749 7.41182C8.02339 7.57492 7.75139 7.68854 7.46685 7.74801V7.84799C7.46685 8.10573 7.25791 8.31466 7.00018 8.31466C6.74245 8.31466 6.53351 8.10573 6.53351 7.84799V7.32959C6.53351 7.20582 6.58268 7.08712 6.6702 6.9996C6.75771 6.91209 6.87641 6.86292 7.00018 6.86292C7.26674 6.86292 7.52732 6.78388 7.74895 6.63578C7.97059 6.48769 8.14334 6.2772 8.24535 6.03093C8.34735 5.78466 8.37404 5.51367 8.32204 5.25223C8.27004 4.99079 8.14168 4.75064 7.95319 4.56215C7.7647 4.37366 7.52455 4.2453 7.26311 4.1933C7.00167 4.14129 6.73068 4.16799 6.48441 4.26999C6.23814 4.372 6.02765 4.54475 5.87956 4.76639C5.73146 4.98802 5.65242 5.2486 5.65242 5.51516C5.65242 5.77289 5.44349 5.98183 5.18575 5.98183C4.92802 5.98183 4.71909 5.77289 4.71909 5.51516C4.71909 5.064 4.85287 4.62298 5.10352 4.24785C5.35417 3.87273 5.71043 3.58036 6.12724 3.40771Z" fill="#4D4D4D" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.0002 1.63353C4.03627 1.63353 1.63353 4.03627 1.63353 7.0002C1.63353 9.96412 4.03627 12.3669 7.0002 12.3669C9.96412 12.3669 12.3669 9.96412 12.3669 7.0002C12.3669 4.03627 9.96412 1.63353 7.0002 1.63353ZM0.700195 7.0002C0.700195 3.5208 3.5208 0.700195 7.0002 0.700195C10.4796 0.700195 13.3002 3.5208 13.3002 7.0002C13.3002 10.4796 10.4796 13.3002 7.0002 13.3002C3.5208 13.3002 0.700195 10.4796 0.700195 7.0002Z" fill="#4D4D4D" />
              </g>
              <defs>
                <clipPath id="clip0_51935_2522">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          {/* </span> */}

          <p className='text-[0.75rem] font-normal leading-4 text-[#4D4D4D] ' >
            How it works
          </p>
        </span>
      </div>


      <div className='flex items-center  w-1/3 px-4 py-2 space-x-1 gap-2 flex-shrink self-stretch bg-[#F2F2F2] '>
        <span className='text-[#808080]'>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_51935_2526)">
              <path d="M6.8 12.0301C3.9328 12.0301 1.6 9.69143 1.6 6.81704C1.6 3.94266 3.9328 1.60401 6.8 1.60401C9.6672 1.60401 12 3.94266 12 6.81704C12 9.69143 9.6672 12.0301 6.8 12.0301ZM12.2792 10.8375C13.1056 9.70827 13.6 8.3216 13.6 6.81704C13.6 3.05805 10.5496 0 6.8 0C3.0504 0 0 3.05805 0 6.81704C0 10.576 3.0504 13.6341 6.8 13.6341C8.4728 13.6341 10.0048 13.0222 11.1896 12.0132L14.0032 14.8339C14.1592 14.9903 14.364 15.0689 14.5688 15.0689C14.7736 15.0689 14.9784 14.9903 15.1344 14.8339C15.4472 14.5203 15.4472 14.0134 15.1344 13.6999L12.2792 10.8375Z" fill="#808080" />
            </g>
            <defs>
              <clipPath id="clip0_51935_2526">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>


        </span>


        <input id='searchbar' type="text" className='font-normal text-[#4D4D4D] bg-[#F2F2F2] text-[0.9375rem] leading-[1.375rem]  w-full outline-none ' placeholder={"Search features, tutorials, etc."} />
      </div>
      <div className='w-1/3 flex flex-col '>
        <div className='flex justify-end items-center gap-3 '>
          <span className='w-9 h-9 flex items-center justify-center flex-shrink-0 text-[#4D4D4D]'>

            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" viewBox="0 0 37 36" fill="none">
              <circle cx="18.5" cy="18" r="18" fill="#E6E6E6" />
              <path d="M26.0789 9.02136L10.5042 12.0441C9.91684 12.1491 9.5 12.7158 9.5 13.3666V20.2517C9.5 20.9025 9.91684 21.4692 10.5042 21.5742L12.0958 21.8891C12.74 23.0646 13.9526 25.1007 15.5821 26.759C16.1316 27.3258 17.0411 26.822 16.9274 25.9824C16.7758 24.8698 16.8137 23.6733 16.8705 22.8337L26.0789 24.6389C26.8179 24.7859 27.5 24.1561 27.5 23.3165V10.3438C27.5 9.50416 26.8179 8.87442 26.0789 9.02136ZM15.3168 17.6698C15.3168 17.9007 15.1463 18.0896 14.9379 18.0896H13.3842C13.1758 18.0896 13.0053 17.9007 13.0053 17.6698V15.9485C13.0053 15.7176 13.1758 15.5287 13.3842 15.5287H14.9379C15.1463 15.5287 15.3168 15.7176 15.3168 15.9485V17.6698ZM19.6558 17.6698C19.6558 17.9007 19.4853 18.0896 19.2768 18.0896H17.7232C17.5147 18.0896 17.3442 17.9007 17.3442 17.6698V15.9485C17.3442 15.7176 17.5147 15.5287 17.7232 15.5287H19.2768C19.4853 15.5287 19.6558 15.7176 19.6558 15.9485V17.6698ZM24.0137 17.6698C24.0137 17.9007 23.8432 18.0896 23.6347 18.0896H22.0811C21.8726 18.0896 21.7021 17.9007 21.7021 17.6698V15.9485C21.7021 15.7176 21.8726 15.5287 22.0811 15.5287H23.6158C23.8242 15.5287 23.9947 15.7176 23.9947 15.9485V17.6698H24.0137Z" fill="#4D4D4D" />
            </svg>


          </span>

          <span className='w-9 h-9 flex items-center justify-center flex-shrink-0 text-[#4D4D4D]'>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <g clip-path="url(#clip0_51935_2537)">
                <circle cx="20" cy="20" r="20" fill="#E6E6E6" />
                <path d="M21.1109 25.5026C20.5156 26.1587 19.4844 26.1587 18.8891 25.5026L13.6151 19.6895C12.7406 18.7256 13.4245 17.1816 14.726 17.1816L25.274 17.1816C26.5755 17.1816 27.2594 18.7256 26.3849 19.6895L21.1109 25.5026Z" fill="#4D4D4D" />
              </g>
              <defs>
                <clipPath id="clip0_51935_2537">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>

      </div>
    </div>
  )
}

export default Navbar